import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, OnDestroy, OnInit } from '@angular/core';
import { StepperService } from '../../services/stepper.service';
import { ProfileSelectionComponent } from '../../components/steps/profile-selection/profile-selection.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TyPageComponent } from '../../components/steps/ty-page/ty-page.component';
import { ActivatedRoute, Router, UrlSegment } from '@angular/router';
import { RequestSelectionComponent } from '../../components/steps/request-selection/request-selection.component';
import { SpecialistSelectionComponent } from '../../components/steps/specialist-selection/specialist-selection.component';
import { stepperConfig } from '../../config/stepper/stepper.config';
import { IStep } from '../../interfaces/step.interface';
import { DateSelectionComponent } from '../../components/steps/date-selection/date-selection.component';
import { SummaryComponent } from '../../components/steps/summary/summary.component';
import { OneRadioInfoComponent } from '../../components/steps/one-radio-info/one-radio-info.component';
import { TipsideComponent } from '../../components/tipside-with-modal/tipside/tipside.component';
import { AppointmentStepperService } from '../../services/appointment-stepper.service';
import { SpecialistCategorizationSelectionComponent } from '../../components/steps/specialist-categorization-selection/specialist-categorization-selection.component';
import { HttpService } from '../../services/http.service';
import { AccountDataDTO, UserAccountDTO, UsersAccountDTO } from '../../classes/user-account.dto';
import { ProfileSelectionCareManagerComponent } from '../../components/steps/profile-selection-care-manager/profile-selection-care-manager.component';
import { forkJoin, Observable, of, tap, catchError, switchMap, take } from 'rxjs';
import { RecapCareManagerComponent } from '../../components/recap-care-manager/recap-care-manager.component';
import { ToastrService } from 'ngx-toastr';
import { SymptomAssessmentIntroComponent } from '../../components/symptom-assessment-intro/symptom-assessment-intro.component';
import { SymptomAssessmentDayPickerComponent } from '../../components/symptom-assessment-day-picker/symptom-assessment-day-picker.component';
import { SymptomAssessmentSymptomsComponent } from '../../components/symptom-assessment-symptoms/symptom-assessment-symptoms.component';
import { DataService } from '../../services/data.service';
import { SymptomAssessmentSurveyComponent } from '../../components/symptom-assessment-survey/symptom-assessment-survey.component';
import { SymptomAssessmentBodymapComponent } from '../../components/symptom-assessment-bodymap/symptom-assessment-bodymap.component';
import { TriageUserDataService } from '../../services/triage-user-data.service';
import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/environment';
import { SummaryConsultationComponent } from '../../components/steps/summary-consultation/summary-consultation/summary-consultation.component';
import { StorageService } from '../../services/storage.service';
import { IInitializePayment } from '../../interfaces/payment.interface';
import { ProfileSelectionInputComponent } from '../../components/steps/profile-selection-input/profile-selection-input.component';
import { format } from "date-fns";
import { GtmService } from '../../services/gtm.service';
import { ConsultTypeService } from '../../services/consult-type.service';
import { NonFocusableStepsDirective } from '../../directives/non-focusable-steps.directive';

interface SessionUpdate {
  symptom?: number;
  request?: string;
  codes?: string[];
  types?: string[];
  questionTypes?: string[];
}

@Component({
    selector: 'app-appointment-handler',
    imports: [
        CommonModule,
        ProfileSelectionComponent,
        TranslateModule,
        TyPageComponent,
        RequestSelectionComponent,
        SpecialistSelectionComponent,
        DateSelectionComponent,
        SummaryComponent,
        OneRadioInfoComponent,
        TipsideComponent,
        SpecialistCategorizationSelectionComponent,
        ProfileSelectionCareManagerComponent,
        RecapCareManagerComponent,
        SymptomAssessmentIntroComponent,
        SymptomAssessmentDayPickerComponent,
        SymptomAssessmentSymptomsComponent,
        SymptomAssessmentSurveyComponent,
        SymptomAssessmentBodymapComponent,
        SummaryConsultationComponent,
        ProfileSelectionInputComponent,
        NonFocusableStepsDirective,
    ],
    templateUrl: './appointment-handler.component.html',
    styleUrl: './appointment-handler.component.scss',
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppointmentHandlerComponent implements OnInit, OnDestroy {
  private _steps?: IStep[];
  stepperSteps: IStep[] = [];
  profileInputChosen?: FormGroup;
  type?: string;
  dates: any = [];
  oldDates: any = [];
  consultTypePhone?: string;
  consultTypeVideo?: string;
  consultType?: string;
  activityCode?: any;
  newUser: boolean = false;
  updatedUser: any;
  body: any;
  hasTravel = false;
  hasDocuments = false;
  hasSurvey = false;
  isVet = false;
  daysAssessment?: number;
  sympthomSelected: any;
  zone: string = '';
  symptoms: any;
  codes?: string[];
  nextStep: string | null = null;
  showUpdateButton: boolean = false;
  showNextButton: boolean = true;
  lastSurveyRequest?: string;
  systemExpert: any;
  expertStep: string | null = null;
  isEnvironment: boolean = false;
  answers: { code: string; value: string }[] = [];
  answer1: { code: string; value: string } = { code: 'recentCase', value: '' };
  answer2: { code: string; value: string } = { code: 'specialCase', value: '0' };
  answer3: { code: string; value: string } = { code: 'sex', value: '' };
  answer5: { code: string; value: string } = { code: 'age', value: '' };
  diagnosis: any;
  companyId?: string;
  payment: boolean = false;
  calendarUrl: string = '';
  minAppointments: any;
  maxAppointments: any;
  modify: boolean = false;
  surveys: any;
  translatedTypes: { [key: string]: string } = {};
  onMobile : boolean = false;
  currentRoute: string | null | undefined;
  selectedRoute: string | null | undefined;
  isConsultTypeSet: boolean = false;
  price: any;
  gtmStepMap: any = {
    GenericPhone: {
      'mode-selection': 'step1_mode',
      'profile-selection': 'step2_profile',
      'request-selection': 'step3_request',
      'recap-care-manager': 'step4_recap',
    },
    GenericVideo: {
      'mode-selection': 'step1_mode',
      'profile-selection': 'step2_profile',
      'request-selection': 'step3_request',
      'recap-care-manager': 'step4_recap',
    },
    SpecialistPhone: {
      'mode-selection': 'step1_mode',
      'profile-selection': 'step2_profile',
      'specialist-selection': 'step3_specialist',
      'request-selection': 'step4_request',
      'date-selection': 'step5_date_hour',
      'summary': 'step6_recap',
    },
    SpecialistVideo: {
      'mode-selection': 'step1_mode',
      'profile-selection': 'step2_profile',
      'specialist-selection': 'step3_specialist',
      'request-selection': 'step4_request',
      'date-selection': 'step5_date_hour',
      'summary': 'step6_recap',
    },
    VeterinarianPhone: {
      'mode-selection': 'step1_mode',
      'request-selection': 'step2_request',
      'date-selection': 'step3_date_hour',
      'summary': 'step4_recap',
    },
    VeterinarianVideo: {
      'mode-selection': 'step1_mode',
      'request-selection': 'step2_request',
      'date-selection': 'step3_date_hour',
      'summary': 'step4_recap',
    },
    PsychologistPhone: {
      'mode-selection': 'step1_mode',
      'profile-selection': 'step2_profile',
      'request-selection': 'step3_request',
      'date-selection': 'step4_date_hour',
      'summary': 'step5_recap',
    },
    PsychologistVideo: {
      'mode-selection': 'step1_mode',
      'profile-selection': 'step2_profile',
      'request-selection': 'step3_request',
      'date-selection': 'step4_date_hour',
      'summary': 'step5_recap',
    },
    GenericTelevisitVideo: {
      'profile-selection': 'step1_profile',
      'request-selection': 'step2_request',
      'date-selection': 'step3_date_hour',
      'summary': 'step4_recap',
    },
    SpecialistTelevisitVideo: {
      'profile-selection': 'step1_profile',
      'specialist-selection': 'step2_specialist',
      'request-selection': 'step3_request',
      'date-selection': 'step4_date_hour',
      'summary': 'step5_recap',
    },
    CareManager: {
      'profile-selection-care-manager': 'step1_profile',
      'profile-selection-input': 'step2_request',
      'one-radio-alimentation': 'step3_date_hour',
      'summary': 'step4_recap',
    },
    TreatmentPathPsiTelevisitFu: {
      'price-selection': 'step0_price',
      'profile-selection': 'step1_profile',
      'request-selection': 'step2_request',
      'one-radio-alimentation': 'step3_reason',
      'date-selection': 'step4_date_hour',
      'summary': 'step5_recap'
    },
    TreatmentPathNutTelevisitFu: {
      'price-selection': 'step0_price',
      'profile-selection': 'step1_profile',
      'request-selection': 'step2_request',
      'one-radio-alimentation': 'step3_reason',
      'date-selection': 'step4_date_hour',
      'summary': 'step5_recap'
    },
    SpecialistTelevisitVideoPayment: {
      'profile-selection': 'step0_price',
    },
    GenericTelevisitVideoPayment: {
      'profile-selection': 'step0_price',
    },
    SymptomsAssessments: {
      'intro': 'step1_intro',
      'days-picker': 'step2_since_when',
      'body-parts': 'step3_where',
      'symptoms': 'step4_symptoms',
      'survey': 'step5_questions',
      'summary-valutation': 'step6_recap'
    }
  };

  get steps(): IStep[] | undefined {
    return this._steps;
  }

  set steps(value: IStep[] | undefined) {
    this._steps = value;
    this.stepperSteps = value?.slice(0, -1) ?? [];
  }


  constructor(
    protected stepperService: StepperService,
    private router: Router,
    protected appointmentStepperService: AppointmentStepperService,
    private route: ActivatedRoute,
    private http: HttpService,
    private cdr: ChangeDetectorRef,
    private dataService: DataService,
    private triageUserDataService: TriageUserDataService,
    private storage: StorageService,
    private translate: TranslateService,
    private gtmService: GtmService,
    private consultTypeService: ConsultTypeService
  ) {
    this.getBookingType();
  }

  public ngOnInit(): void {
    this.price = localStorage.getItem('price');
    this.onMobile = window.innerWidth <= 768; 
    this.appointmentStepperService.setAppointmentType(null);
    this.getProfiles();
    this.showUpdateButton = false;
    this.showNextButton = true;
    this.syncButtonStates();
    this.dataService.companyId$.subscribe((companyId) => {
      this.companyId = companyId;
    });
    this.dataService.getCalendarUrl().subscribe((res) => {
      console.log(res);
      this.calendarUrl = res;
    });

    this.translate.onLangChange.subscribe(() => {
      this.loadTranslatedTypes();
    });

    this.consultTypeService.type$.subscribe(type => {
      const urlSegments = this.route.snapshot.url.length > 0
        ? this.route.snapshot.url
        : this.route.parent?.snapshot.url || [];
      const lastSegment = urlSegments.length > 0
        ? urlSegments[urlSegments.length - 1].path
        : null;
      const specialistType = this.appointmentStepperService.getSpecialistData()?.value.specialistType.description;
      const storedConsultType = localStorage.getItem('consultType');
      if (this.isConsultTypeSet) {
        return;
      }
      if (storedConsultType) {
        this.consultType = storedConsultType;
        this.isConsultTypeSet = true;
        return; 
      }
      if (lastSegment === 'specialist-consultation') {
          if (type === 'Video') {
            this.consultType = 'SpecialistVideo';
          } else if (type === 'Phone') {
            this.consultType = 'SpecialistPhone';
          } else if (type === 'TelevisitVideo') {
            this.consultType = 'SpecialistTelevisitVideo';
          } else if (type === 'TelevisitPhone') {
            this.consultType = 'SpecialistTelevisitPhone';
          }
      } else if (lastSegment === 'generic-consultation') {
          if (type === 'Video') {
            this.consultType = 'GenericVideo';
          } else if (type === 'Phone') {
            this.consultType = 'GenericPhone';
          } else if (type === 'TelevisitVideo') {
            this.consultType = 'GenericTelevisitVideo';
          } else if (type === 'TelevisitPhone') {
            this.consultType = 'GenericTelevisitPhone';
          }
      } else if (lastSegment === 'psyco-pathway') {
          if (type === 'Video') {
            this.consultType = 'PsychologistVideo';
          } else if (type === 'Phone') {
            this.consultType = 'PsychologistPhone';
          }
      } else if (lastSegment === 'nut-pathway') {
        this.consultType = 'TreatmentPathNutTelevisit';
      } else if (lastSegment === 'care-manager') {
        this.consultType = 'CareManager';
      } else if (lastSegment === 'vet-consultation') {
          if (type === 'Video') {
            this.consultType = 'VeterinarianVideo';
          } else if (type === 'Phone') {
            this.consultType = 'VeterinarianPhone';
          } 
      } else if (lastSegment === 'discover-care-pathway') {
        if (specialistType === 'Psicologo') {
            this.consultType = 'TreatmentPathPsiTelevisitFu';
        } else if(specialistType === 'Nutrizionista'){
          this.consultType = 'TreatmentPathNutTelevisitFu';
        } else if(specialistType === undefined){
            if(storedConsultType){
              this.consultType = storedConsultType
            }
        }
      }
      if(this.consultType){
        localStorage.setItem('consultType', this.consultType);
        this.isConsultTypeSet = true;
      }
    }
    );
    const initialStep = this.stepperService.currentStep;
    this.gtmService.pushVirtualPage(
      initialStep,
      '/' + `step_${this.stepperService.indexCurrentStep + 1}_${initialStep}`
    );
    this.route.queryParams.subscribe(params => {
      if (params['IDPAGAMENTO']) {
        const price = localStorage.getItem('price');
        const consultType = localStorage.getItem('consultType');
        if (consultType) {
          const successEvent = {
              event: consultType,
              step: `${consultType}_success`,
              ...(price ? { price } : {})
          };
          if (price) {
            successEvent.price = price;
          }
          console.log('GTM success event:', successEvent);
          this.gtmService.pushConsultEvent(successEvent);
        }
      }
    });
  }

  private loadTranslatedTypes(): void {
    this.translate.get('ourServices.servicesList').subscribe((servicesList: any[]) => {
      this.translatedTypes = {};

      servicesList.forEach((service) => {
        this.translatedTypes[service.buttonRoute] = service.title;
      });

      this.getUrl();
    });
  }

  private loadTranslatedStepTitle(steps: any[]): void {
    const keys = steps.filter((step) => !!step.stepTitleKey).map((step) => step.stepTitleKey);
    this.translate.get(keys).subscribe((translations) => {
      steps.forEach((step) => {
        if (step.stepTitleKey && translations[step.stepTitleKey]) {
          step.stepTitle = translations[step.stepTitleKey];
        }
      });
    });
  }

  private getBookingType(): void {
    this.loadTranslatedTypes();
    if (this.steps) {
      this.stepperService.steps = this.steps.map((step: IStep) => step.stepId);
    }
  }

  private getUrl(): void {
    const urlSegmentsModify: UrlSegment[] = this.route.snapshot.url;
    const urlSegments: UrlSegment[] = urlSegmentsModify.length > 0 ? urlSegmentsModify : this.route.parent?.snapshot.url!;
    const lastSegment: string | null = urlSegments.length > 0 ? urlSegments[urlSegments.length - 1].path : null;
    this.currentRoute = lastSegment;
    let consultType = localStorage.getItem('consultType');
    const paymentResult = this.route.snapshot.queryParamMap.get('MESSAGGIO_1');
    if (paymentResult && paymentResult === 'Success') {
      const mainUserData = JSON.parse(this.storage.getItem('userData')!);
      const userData = this.appointmentStepperService.getMainUser() ? this.appointmentStepperService.getMainUser() : JSON.parse(localStorage.getItem('userData')!);
      const bodyAppointment = JSON.parse(this.storage.getItem('bodyAppointment')!);
      const bodyUserLog = JSON.parse(this.storage.getItem('bodyUserLog')!);
      const bodyApiNotification = JSON.parse(this.storage.getItem('bodyApiNotification')!);
      let specialist = bodyAppointment.specialist;
      if (consultType === 'SpecialistTelevisitVideoPayment' || consultType === 'GenericTelevisitVideoPayment') {
        specialist = consultType;
      }
      forkJoin({
        scheduleAppointment: this.http.scheduleAppointment(bodyAppointment, { currentContactId: userData.individualId, individualId: mainUserData.individualId }, 'it', specialist),
        sendApiNotification: this.http.sendApinotification(bodyApiNotification),
      }).subscribe((_) => {
        this.storage.removeItem('bodyAppointment');
        this.storage.removeItem('bodyUserLog');
        this.storage.removeItem('bodyApiNotification');
      });
      this.stepperService.currentStep = 'ty-page';
      return;
    }
    switch (lastSegment) {
      case 'televisit-generic-booking':
        this.steps = stepperConfig.televisitGenericBooking.map((step) => ({
          ...step,
          stepTitleKey: step.stepTitle,
        }));
        this.loadTranslatedStepTitle(this.steps);
        this.type = this.translatedTypes['televisit-generic-booking'];
        this.consultTypePhone = 'GenericTelevisitVideo';
        this.consultTypeVideo = 'GenericTelevisitVideo';
        return;
      case 'televisit-specialist-booking':
        this.steps = stepperConfig.televisitSpecialistBooking.map((step) => ({
          ...step,
          stepTitleKey: step.stepTitle,
        }));
        this.loadTranslatedStepTitle(this.steps);
        this.type = this.translatedTypes['televisit-specialist-booking'];
        this.consultTypePhone = 'SpecialistTelevisitVideo';
        this.consultTypeVideo = 'SpecialistTelevisitVideo';
        return;
      case 'generic-consultation':
        this.steps = stepperConfig.genericConsultation.map((step) => ({
          ...step,
          stepTitleKey: step.stepTitle,
        }));
        this.loadTranslatedStepTitle(this.steps);
        this.type = this.translatedTypes['generic-consultation'];
        this.hasTravel = true;
        this.consultTypePhone = 'GenericPhone';
        this.consultTypeVideo = 'GenericVideo';
        return;
      case 'specialist-consultation':
        this.steps = stepperConfig.specialistConsultation.map((step) => ({
          ...step,
          stepTitleKey: step.stepTitle,
        }));
        this.loadTranslatedStepTitle(this.steps);
        this.type = this.translatedTypes['specialist-consultation'];
        this.consultTypePhone = 'SpecialistPhone';
        this.consultTypeVideo = 'SpecialistVideo';
        return;
      case 'care-pathway':
        this.steps = stepperConfig.carePathway.map((step) => ({
          ...step,
          stepTitleKey: step.stepTitle,
        }));
        this.loadTranslatedStepTitle(this.steps);
        this.hasDocuments = true;
        this.type = this.translatedTypes['care-pathway'];
        return;
      case 'psyco-pathway':
        this.steps = stepperConfig.psyConsultation.map((step) => ({
          ...step,
          stepTitleKey: step.stepTitle,
        }));
        this.loadTranslatedStepTitle(this.steps);
        this.hasDocuments = false;
        this.type = this.translatedTypes['psyco-pathway'];
        this.consultTypePhone = 'PsychologistPhone';
        this.consultTypeVideo = 'PsychologistVideo';
        this.appointmentStepperService.setSpecialistData(
          new FormGroup({
            specialistType: new FormControl({ description: 'Psicologo', id: 6 }, [Validators.required]),
          })
        );
        return;
      case 'nut-pathway':
        this.steps = stepperConfig.psyConsultation.map((step) => ({
          ...step,
          stepTitleKey: step.stepTitle,
        }));
        this.loadTranslatedStepTitle(this.steps);
        this.hasDocuments = false;
        this.type = this.translatedTypes['nut-pathway'];
        this.hasSurvey = true;
        this.consultTypePhone = 'treatmentPathNutTelevisit';
        this.appointmentStepperService.setSpecialistData(
          new FormGroup({
            specialistType: new FormControl({ description: 'Nutrizionista', id: 5 }, [Validators.required]),
          })
        );
        return;
      case 'first-nut-pathway':
        this.steps = stepperConfig.discoverCarePathway.map((step) => ({
          ...step,
          stepTitleKey: step.stepTitle,
        }));
        this.loadTranslatedStepTitle(this.steps);
        this.hasDocuments = false;
        this.hasSurvey = true;
        this.type = this.translatedTypes['first-nut-pathway'];
        this.consultTypeVideo = 'TreatmentPathNutTelevisit';
        this.consultTypePhone = 'TreatmentPathNutTelevisit';
        this.appointmentStepperService.setSpecialistData(
          new FormGroup({
            specialistType: new FormControl({ description: 'Nutrizionista', id: 5 }, [Validators.required]),
          })
        );
        return;
      case 'first-psyco-pathway':
        this.steps = stepperConfig.discoverCarePathway
        .filter(step => step.stepId !== 'one-radio-alimentation')
        .map((step) => ({
          ...step,
          stepTitleKey: step.stepTitle,
        }));
        this.loadTranslatedStepTitle(this.steps);
        this.hasDocuments = false;
        this.hasSurvey = false;
        this.type = this.translatedTypes['first-psyco-pathway'];
        this.consultTypeVideo = 'TreatmentPathPsiTelevisit';
        this.consultTypePhone = 'TreatmentPathPsiTelevisit';
        this.appointmentStepperService.setSpecialistData(
          new FormGroup({
            specialistType: new FormControl({ description: 'Psicologo', id: 6 }, [Validators.required]),
          })
        );
        return;
      case 'care-manager':
        this.steps = stepperConfig.careManager.map((step) => ({
          ...step,
          stepTitleKey: step.stepTitle,
        }));
        this.loadTranslatedStepTitle(this.steps);
        if (localStorage.getItem('skipCareManagerIntro') === 'true') {
          this.steps.shift();
          this.stepperSteps = this.steps.slice(0, -1);
        }
        this.type = this.translatedTypes['care-manager'];
        this.consultTypePhone = 'CareManager';
        return;
      case 'discover-care-pathway':
        this.payment = true;
        this.steps = stepperConfig.discoverCarePathway.map((step) => ({
          ...step,
          stepTitleKey: step.stepTitle,
        }));
        this.loadTranslatedStepTitle(this.steps);
        this.type = this.translatedTypes['discover-care-pathway'];
        this.hasSurvey = true;
        this.hasDocuments = true;
        if (this.appointmentStepperService.getSpecialistData()?.value.specialistType.description === 'Psicologo') {
          this.consultTypeVideo = 'TreatmentPathPsiTelevisitFu';
          this.consultTypePhone = 'TreatmentPathPsiTelevisitFu';
        } else {
          this.consultTypeVideo = 'TreatmentPathNutTelevisitFu';
          this.consultTypePhone = 'TreatmentPathNutTelevisitFu';
        }
        if (history.state.sodType === 0) {
          this.steps = stepperConfig.televisitGenericBooking;
          this.consultTypePhone = 'GenericTelevisitVideoPayment';
          this.consultTypeVideo = 'GenericTelevisitVideoPayment';
          this.hasDocuments = false;
          this.hasSurvey = false;
        } else if (history.state.sodType === 1) {
          this.steps = stepperConfig.televisitSpecialistBooking;
          this.consultTypePhone = 'SpecialistTelevisitVideoPayment';
          this.consultTypeVideo = 'SpecialistSpecialistTelevisitFU';
          this.hasDocuments = false;
          this.hasSurvey = false;
        }
        return;
      case 'vet-consultation':
        this.steps = stepperConfig.vet.map((step) => ({
          ...step,
          stepTitleKey: step.stepTitle,
        }));
        this.loadTranslatedStepTitle(this.steps);
        this.type = this.translatedTypes['vet-consultation'];
        this.consultTypePhone = 'VeterinarianPhone';
        this.consultTypeVideo = 'VeterinarianVideo';
        this.dataService.getAccountData().subscribe((account: UsersAccountDTO) => {
          this.appointmentStepperService.setUsers(account);
        });

        return;
      case 'new-valutation':
        this.steps = stepperConfig.newValutation.map((step) => ({
          ...step,
          stepTitleKey: step.stepTitle,
        }));
        this.loadTranslatedStepTitle(this.steps);
        this.consultType = 'SymptomsAssessments';
        return;
      case 'modify':
        this.dataService.getDatesByModify().subscribe((res) => {
          if (res) {
            this.steps = stepperConfig.modify.map((step) => ({
              ...step,
              stepTitleKey: step.stepTitle,
            }));
            this.loadTranslatedStepTitle(this.steps);
            this.setCalendarConfigs(res);
            this.modify = true;
          }
        });
        return;
      default:
        return;
    }
  }

  protected getProfiles(): void {
    const activeUser: UserAccountDTO = JSON.parse(localStorage.getItem('userData')!);
    this.http.getUsers(activeUser).subscribe((res: any) => {
      if (res) {
        this.appointmentStepperService.setUsers(res);
        if (this.modify) {
          this.appointmentStepperService.setMainUser(res);
        }
      }
    });
  }

  protected isSectionVisible(): boolean {
    return (
      this.stepperService.hasNextStep() &&
      this.stepperService.hasPreviousStep() &&
      this.stepperService.currentStep !== 'summary' &&
      this.stepperService.currentStep !== 'summary-valutation' &&
      this.stepperService.currentStep !== 'profile-selection' &&
      this.stepperService.currentStep !== 'profile-selection-care-manager' &&
      this.stepperService.currentStep !== 'profile-selection-input'
    );
  }

  protected profileInputData(event: FormGroup): void {
    this.profileInputChosen = event;
    this.isDisabled(this.stepperService.currentStep);
    this.cdr.detectChanges();
  }

  protected setRequestSelectionData(item: any): void {
    this.appointmentStepperService.setSelectionData(item);
    this.isDisabled(this.stepperService.currentStep);
    this.cdr.detectChanges();
  }

  protected setTravelData(item: any): void {
    this.appointmentStepperService.setTravelFormData(item);
    this.isDisabled(this.stepperService.currentStep);
    this.cdr.detectChanges();
  }

  protected setSurveyAnswers(item: any): void {
    this.appointmentStepperService.setRadioAlimentationData(item);
    this.isDisabled(this.stepperService.currentStep);
    this.cdr.detectChanges();
  }

  protected isDisabled(step: string): boolean {
    switch (step) {
      case 'mode-selection':
        return !this.appointmentStepperService.getAppointmentType();
      case 'profile-selection':
      case 'profile-selection-care-manager':
        return !this.appointmentStepperService.getMainUser();
      case 'profile-selection-input':
        return !this.profileInputChosen?.valid;
      case 'specialist-selection': 
        return !this.appointmentStepperService.getSpecialistData()?.valid;
      case 'specialist-categorization-selection':
        return !this.appointmentStepperService.getSpecialistData()?.valid;
      case 'request-selection': {
        if (this.appointmentStepperService.getTravelFormData()?.form?.valid !== undefined) {
          return !(this.appointmentStepperService.getSelectionData()?.valid && this.appointmentStepperService.getTravelFormData()?.form?.valid);
        }
        return !this.appointmentStepperService.getSelectionData()?.valid;
      }
      case 'date-selection': {
        if (this.appointmentStepperService.getDateSelectionData()) {
          if (
            this.appointmentStepperService.getDateSelectionData()!.length >= this.minAppointments &&
            this.appointmentStepperService.getDateSelectionData()!.length <= this.maxAppointments
          ) {
            return false;
          }
        }
        return true;
      }
      case 'one-radio-alimentation':
        const form = this.appointmentStepperService.getRadioAlimentationData();
        return form && form.valid ? false : form === null ? false : true;
      case 'intro':
        return false;
      case 'days-picker':
        return false;
      case 'body-parts':
        return false;
      case 'symptoms':
        return !this.sympthomSelected;
      case 'survey':
        return false;
      case 'summary':
        return false;
      case 'summary-valutation':
        return false;
      case 'recap-care-manager':
        return false;
      default:
        return true;
    }
  }

protected handleNextStep(): void {
  this.handleRequests(this.stepperService.currentStep)?.subscribe((res) => {
    if (!res) return;
    const currentIndex = this.stepperService.indexCurrentStep;
    const nextIndex = currentIndex + 1;
    const rawNextStep = this.stepperService.steps?.[nextIndex];
    if (rawNextStep) {
      const consultType = localStorage.getItem('consultType');
      const normalizedStep =
        rawNextStep === 'specialist-categorization-selection'
          ? 'specialist-selection'
          : rawNextStep;
      const pagePath =
        consultType && this.gtmStepMap[consultType]?.[normalizedStep]
          ? this.gtmStepMap[consultType][normalizedStep]
          : normalizedStep;
      this.gtmService.pushVirtualPage(rawNextStep, pagePath);
    }
    const consultType = localStorage.getItem('consultType');
    if (consultType) {
      let eventName = consultType;
      if (consultType === 'SymptomAssessment') {
        eventName = 'symptom_assessment';
      }
      const currentStep = this.stepperService.currentStep;
      const normalizedCurrentStep =
        currentStep === 'specialist-categorization-selection'
          ? 'specialist-selection'
          : currentStep;
      const gtmStep = this.gtmStepMap[consultType]?.[normalizedCurrentStep];
      const price = localStorage.getItem('price');
      if (gtmStep) {
        const eventData: Record<string, any> = {
          event: eventName,
          step: gtmStep,
          ...(price ? { price } : {})
        };
        this.gtmService.pushConsultEvent(eventData);
      }
    } else {
      console.warn('consultType non trovato in localStorage');
    }
    this.stepperService.nextStep(this.stepperService.currentStep);
    window.scrollTo(0, 0);
    this.cdr.detectChanges();
  });
}

  protected handlePreviousStep(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (this.stepperService.hasPreviousStep()) {
      this.stepperService.previousStep(this.stepperService.currentStep);
    } else {
      this.router.navigate(['home']).then();
    }
  }

  protected handleSurveyUpdate(): void {
    const sessionUpdate = this.prepareExpertUpdate();

    if (sessionUpdate.request === 'specifications') {
      this.showUpdateButton = false;
      this.showNextButton = true;
    } else {
      this.showUpdateButton = true;
      this.showNextButton = false;
    }

    this.cdr.detectChanges();

    this.updateSession('survey').subscribe((response) => {
      if (response) {
        if (response.request === 'specifications') {
          this.showUpdateButton = false;
          this.showNextButton = true;
        } else if (response.nextStep === 'questions') {
          this.showUpdateButton = true;
          this.showNextButton = false;

          this.dataService.getSessionId().subscribe((sessionId) => {
            if (sessionId) {
              this.http.systemExpert(sessionId).subscribe((systemExpertResponse) => {
                this.systemExpert = systemExpertResponse;
                const firstQuestionLabel = systemExpertResponse.questions[0]?.label;
                if (firstQuestionLabel === 'Nella sua città è attivo un servizio di guardia medica 24/7?') {
                  this.showUpdateButton = false;
                  this.showNextButton = true;
                }

                this.cdr.detectChanges();
              });
            }
          });
        } else if (response.nextStep === 'SystemExpertDiagnoses') {
          this.showUpdateButton = false;
          this.showNextButton = true;
        }

        window.scrollTo(0, 0);
        this.cdr.detectChanges();
      }
    });
  }

  private handleRequests(currentStep: string): Observable<any> {
    switch (currentStep) {
      case 'mode-selection': {
      this.consultType =
        this.appointmentStepperService.getAppointmentType() === 'Video'
          ? this.consultTypeVideo
          : this.consultTypePhone;
      localStorage.setItem('consultType', this.consultType!);
      return of(true);
      }

      case 'profile-selection':
      case 'profile-selection-care-manager': {
        return this.getProfileSelection(currentStep);
      }

      case 'request-selection':
      case 'one-radio-alimentation': {
        const dateSelection = this.steps?.find((step) => step.stepId === 'date-selection');
        if (currentStep === 'request-selection' && this.hasSurvey) {
          return this.http.getSurveyValues(this.consultTypePhone!).pipe(
            tap((res) => {
              this.surveys = this.setSurveys(res);
            })
          );
        }
        if (this.consultTypePhone !== 'CareManager' && dateSelection !== undefined) {
          localStorage.setItem('consultType', this.consultTypePhone!);
          const todayDate = new Date();
          const body = {
            activityCode: this.activityCode,
            language: 'it',
            startingMonth: todayDate.getMonth() + 1,
            startingYear: todayDate.getFullYear(),
            token: localStorage.getItem('authToken')?.replaceAll('"', ''),
          };
          return this.http.getCalendarDates(body, this.calendarUrl).pipe(
            tap((res) => {
              this.setCalendarConfigs(res);
            })
          );
        }
        return of(true);
      }

      case 'intro': {
        const userData = JSON.parse(localStorage.getItem('userData')!);
        return this.http.createSessionWithLanguage(userData.individualId).pipe(
          switchMap((res) => {
            if (res?.id) {
              this.dataService.setSessionId(res.id);
              return this.fetchProfile();
            }
            return of(false);
          }),
          catchError((error) => {
            console.error('Error creating session:', error);
            return of(false);
          })
        );
      }

      case 'days-picker': {
        return this.updateSession(this.stepperService.currentStep);
      }

      case 'body-parts': {
        return this.dataService.getSessionId().pipe(
          switchMap((sessionId) => {
            if (!sessionId) {
              console.error('Session ID is missing');
              return of(false);
            }
            if (!this.zone) {
              console.error('Zone is not defined');
              return of(false);
            }
            return this.http.symptomsByZone(sessionId, this.zone).pipe(
              tap((response) => {
                this.triageUserDataService.set('symptoms', response.symptoms);
                this.symptoms = response.symptoms;
              }),
              catchError((error) => {
                console.error('Error fetching symptoms for zone:', error);
                return of(false);
              })
            );
          })
        );
      }

      case 'profile-selection-input': {
        this.sendUpdateUser();
        this.sendUpdateDoctorData();
        const type = this.appointmentStepperService.getAppointmentType() === 'Video' ? this.consultTypeVideo! : this.consultTypePhone!;
        return this.http.getSurveyValues(type).pipe(
          tap((res) => {
            this.surveys = this.setSurveys(res);
          })
        );
      }

      case 'symptoms': {
        return this.updateSession(this.stepperService.currentStep).pipe(
          switchMap((sessionUpdated) => {
            if (!sessionUpdated) {
              console.error('Session update failed');
              return of(false);
            }

            return this.dataService.getSessionId().pipe(
              switchMap((sessionId) => {
                if (!sessionId) {
                  console.error('Session ID is missing');
                  return of(false);
                }

                return this.http.systemExpert(sessionId).pipe(
                  tap((response) => {
                    this.systemExpert = response;
                    this.checkEnvironment();
                  }),
                  catchError((error) => {
                    console.error('Error fetching system expert questions:', error);
                    return of(false);
                  })
                );
              })
            );
          })
        );
      }

      case 'survey': {
      const userData = this.appointmentStepperService.getMainUser() ? this.appointmentStepperService.getMainUser() : JSON.parse(localStorage.getItem('userData')!);
      return this.updateSession(currentStep).pipe(
        switchMap(response => {
          this.nextStep = response.nextStep;
          this.syncButtonStates();
          return this.dataService.getSessionId().pipe(
            tap(sessionId => {
              if (!sessionId) return;
              const bodyApiNotification = this.createApiNotificationBody(userData, 'EndTriage');
              this.http.sendApinotification(bodyApiNotification)
                .pipe(take(1))
                .subscribe({
                  error: err => console.error('Error sendApiNotification:', err)
                });
            }),
            switchMap(sessionId => {
              if (!sessionId) {
                console.error('Session ID is missing');
                return of(false);
              }
              if (this.nextStep === 'SystemExpertDiagnoses') {
                return this.http.getDiagnosis(sessionId).pipe(
                  tap(diagnosisResponse => (this.diagnosis = diagnosisResponse))
                );
              }
              console.warn('Unhandled nextStep:', response.nextStep);
              return of(false);
            })
          );
        }),
        catchError(error => {
          console.error('Error in survey step:', error);
          return of(false);
        })
      );
      }

      case 'summary': {
        const userData = this.appointmentStepperService.getMainUser() ? this.appointmentStepperService.getMainUser() : JSON.parse(localStorage.getItem('userData')!);
        const mainUserData = !!JSON.parse(this.storage.getItem('oldUserData')!) ? JSON.parse(this.storage.getItem('oldUserData')!) : JSON.parse(this.storage.getItem('userData')!);
        const bodyUserLog = this.createUserBody(userData);
        const bodyApiNotification = this.createApiNotificationBody(userData, 'UsedBySecondaryUser');
        if (this.payment) {
          this.storage.setItem('bodyUserLog', bodyUserLog);
          this.storage.setItem('bodyApiNotification', bodyApiNotification);
          return this.checkPayment();
        }
        if (this.modify) {
          return this.modifyAppointment();
        }
        this.body = this.getBodyForSchedule();
        return forkJoin({
          scheduleAppointment: this.http.scheduleAppointment(
            this.body,
            { currentContactId: userData.individualId, individualId: mainUserData.individualId },
            'it',
            this.appointmentStepperService.getAppointmentType() === 'Video' ? this.consultTypeVideo! : this.consultTypePhone!
          ),
          sendApiNotification: this.http.sendApinotification(bodyApiNotification),
        }).pipe(
          tap((results) => {
            console.log('Results:', results);
            localStorage.removeItem('price');
             if (results.scheduleAppointment) {
              const consultType = this.consultType || localStorage.getItem('consultType');
              if (consultType) {
                const successEvent = {
                  event: `${consultType}_success`,
                  step: 'success'
                };
                console.log('GTM success event:', successEvent);
                this.gtmService.pushConsultEvent(successEvent);
              }
            }
          })
        );
      }

      default: {
        console.log('Default case reached.');
        return of(true);
      }
    }
  }
  private fetchProfile(): Observable<any> {
    const userData = JSON.parse(localStorage.getItem('userData')!);

    return this.http.medicalProfile(userData.individualId).pipe(
      tap((profile) => {
        const birthDate = new Date(profile.birthdate);
        const age = this.calculateAge(birthDate);

        this.answer5.value = age.toString();
        this.answer3.value = profile.gender === 'F' ? '2' : '1';

        this.triageUserDataService.set('age', age);
        this.triageUserDataService.set('gender', profile.gender);
      }),
      catchError((error) => {
        console.error('Error fetching profile:', error);
        return of(null);
      })
    );
  }

  private calculateAge(birthDate: Date): number {
    const now = new Date();
    let age = now.getFullYear() - birthDate.getFullYear();
    const monthDifference = now.getMonth() - birthDate.getMonth();

    if (monthDifference < 0 || (monthDifference === 0 && now.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  public setDaysAssessment(days: number): void {
    this.answer1.value = days.toString();
    this.triageUserDataService.set('recentCase', days.toString());
  }

  private getProfileSelection(type: string): Observable<any> {
    this.consultType = this.appointmentStepperService.getAppointmentType() === 'Video' ? this.consultTypeVideo : this.consultTypePhone;
    const data = {
      currentContactId: this.appointmentStepperService.getMainUser()?.individualId
        ? this.appointmentStepperService.getMainUser()?.individualId
        : JSON.parse(localStorage.getItem('userData')!).individualId,
      surveyValues: [],
    };
    return this.http.canSendRequest(this.consultType!, data, type).pipe(
      tap((res: any) => {
        this.activityCode = res?.activityCode;
      })
    );
  }

  private createUserBody(userData: any) {
    const todayDate = new Date();
    return {
      CompanyId: this.companyId!,
      IndividualId: userData.individualId,
      UserId: userData.individualId,
      GrantTo: '',
      EventType: '',
      EventValue: '',
      EventTypeEnum: 2,
      CreatedOn: todayDate,
      CreatedBy: userData.individualId,
    };
  }

  private createApiNotificationBody(userData: any, serviceType: string) {
    const todayDate = new Date();
    return {
      individualId: userData.individualId,
      companyId: this.companyId,
      creationDate: todayDate,
      startDate: todayDate,
      phoneNumber: userData?.phone ? userData.phone : userData.phoneNumber,
      emailAddress: userData?.email ? userData.email : userData.emailAddress,
      serviceType: serviceType,
      instanceCode: '',
      languageCode: 'it',
      endDate: todayDate,
      placeHolderValuesJSON: btoa(JSON.stringify({user: userData.name, notificationDate: format(new Date(), "eee MMM dd yyyy HH:mm:ss 'GMT'xxx")})),
    };
  }

  public setBody(body: any) {
    this.body = body;
  }

  getDate(isoDate: string): string {
    return isoDate.split('T')[0];
  }

  formatTime(isoDate: string): string {
    const date = new Date(isoDate);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  createTimeSlot(item: any): { label: string; value: string; checked: boolean; disabled: boolean } {
    const start = this.formatTime(item.dateFrom);
    const end = this.formatTime(item.dateTo);
    return {
      label: `${start} - ${end}`,
      value: `${start}-${end}`,
      checked: false,
      disabled: item.status === 'UNAVAILABLE',
    };
  }

  groupScheduleByDate(scheduleItems: any[]): any[] {
    if (!scheduleItems.length) return [];
    scheduleItems.sort((a, b) => new Date(a.dateFrom).getTime() - new Date(b.dateFrom).getTime());
    const today = new Date();
    const todayDayOfWeek = today.getUTCDay();
    const daysSinceMonday = todayDayOfWeek === 0 ? 6 : todayDayOfWeek - 1;
    const currentMonday = new Date(today);
    currentMonday.setUTCDate(today.getUTCDate() - daysSinceMonday);
    currentMonday.setUTCHours(0, 0, 0, 0);
    scheduleItems = scheduleItems.filter((item) => new Date(item.dateFrom) >= currentMonday);
    if (!scheduleItems.length) return [];
    const firstDate = new Date(this.getDate(scheduleItems[0].dateFrom));
    const firstDayOfWeek = firstDate.getUTCDay();
    const grouped: Record<string, { label: string; value: string; checked: boolean; disabled: boolean }[]> = {};

    if (firstDayOfWeek !== 1) {
      const missingDays = firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1;
      const startDate = new Date(firstDate);
      startDate.setUTCDate(firstDate.getUTCDate() - missingDays);

      for (let i = 0; i < missingDays; i++) {
        const missingDate = new Date(startDate);
        missingDate.setUTCDate(startDate.getUTCDate() + i);
        const formattedDate = this.getDate(missingDate.toISOString());
        grouped[formattedDate] = [];
      }
    }
    scheduleItems.forEach((item) => {
      const date = this.getDate(item.dateFrom);
      if (!grouped[date]) {
        grouped[date] = [];
      }
      grouped[date].push(this.createTimeSlot(item));
    });
    return Object.entries(grouped).map(([date, timeslots]) => ({
      date,
      timeslots,
      disabled: timeslots.length === 0,
    }));
  }

  public ngOnDestroy(): void {
    this.appointmentStepperService.clearData();
  }

  public setSymptom(symptom: any): void {
    this.sympthomSelected = symptom;
  }

  private checkEnvironment(): void {
    if (this.systemExpert?.questions?.length) {
      this.isEnvironment = this.systemExpert.questions.some((q: any) => q.type === 'environment');
    }
  }

  private updateSession(currentStep: string): Observable<any> {
    const sessionUpdate: SessionUpdate = (() => {
      switch (currentStep) {
        case 'days-picker':
          return this.prepareSessionUpdate();
        case 'symptoms':
          return this.prepareSymptomUpdate();
        case 'survey':
          return this.prepareExpertUpdate();
        default:
          throw new Error(`Unhandled step: ${currentStep}`);
      }
    })();

    if (currentStep === 'symptoms') {
      this.lastSurveyRequest = sessionUpdate.request;

      if (sessionUpdate.request === 'specifications' || sessionUpdate.request === 'environment') {
        this.showUpdateButton = false;
        this.showNextButton = true;
      } else {
        this.showUpdateButton = true;
        this.showNextButton = false;
      }

      this.cdr.detectChanges();
    } else {
      this.showUpdateButton = false;
      this.showNextButton = true;
      this.cdr.detectChanges();
    }

    return this.dataService.getSessionId().pipe(
      switchMap((sessionId) => {
        if (!sessionId) {
          console.error('Session ID is missing');
          return of(false);
        }

        return this.http.updateSession(sessionId, sessionUpdate).pipe(
          tap((response) => {
            if (currentStep === 'symptoms') {
              if (this.lastSurveyRequest === 'specifications' || this.lastSurveyRequest === 'environment') {
                this.showUpdateButton = false;
                this.showNextButton = true;
              } else {
                this.showUpdateButton = true;
                this.showNextButton = false;
              }
              this.cdr.detectChanges();
            }
          }),
          catchError((error) => {
            console.error('Error updating session:', error);
            return of(false);
          })
        );
      })
    );
  }

  private prepareSessionUpdate(): SessionUpdate {
    const sessionUpdate: SessionUpdate = {
      request: 'profiles',
      codes: [],
      types: [],
      questionTypes: [],
    };

    const gender = this.triageUserDataService.get('gender');

    const answers = [
      { code: 'recentCase', value: this.triageUserDataService.get('recentCase') },
      { code: 'specialCase', value: '0' }, // Caso fisso
      { code: 'sex', value: gender === 'M' ? '1' : gender === 'F' ? '2' : '' },
      { code: 'age', value: this.triageUserDataService.get('age') || '' },
    ];

    answers.forEach((answer) => {
      if (answer.value) {
        if (sessionUpdate.codes) {
          sessionUpdate.codes.push(answer.code);
        }
        if (sessionUpdate.types) {
          sessionUpdate.types.push(answer.value);
        }
      }
    });

    return sessionUpdate;
  }

  private prepareSymptomUpdate(): SessionUpdate {
    return {
      request: 'symptom',
      codes: [],
      types: [],
      questionTypes: [],
      symptom: this.sympthomSelected.id,
    };
  }

  private prepareExpertUpdate(): SessionUpdate {
    const sessionUpdate: SessionUpdate = {
      request: '',
      codes: [...(this.codes || [])],
      types: [],
      questionTypes: [],
    };

    for (const question of this.systemExpert.questions) {
      if (question.answers) {
        for (const answer of question.answers) {
          if (this.codes?.includes(answer.code)) {
            if (sessionUpdate.questionTypes) {
              sessionUpdate.questionTypes.push(question.type);
            }
          }
        }
      }

      if (question.questions) {
        for (const subQuestion of question.questions) {
          for (const subAnswer of subQuestion.answers) {
            if (this.codes?.includes(subAnswer.code)) {
              if (sessionUpdate.questionTypes) {
                sessionUpdate.questionTypes.push(subQuestion.type);
              }
            }
          }

          if (!subQuestion.multiple) {
            if (sessionUpdate.types) {
              sessionUpdate.types.push(subQuestion.code);
            }
          }
        }
      }
      if (sessionUpdate.request === 'environment') {
        const uniqueCodes = new Set<string>();
        this.systemExpert.questions.forEach((question: { code: string }) => {
          if (question.code?.startsWith('environment:')) {
            const extractedCode = question.code.replace('environment:', '');
            uniqueCodes.add(extractedCode);
          }
        });
        sessionUpdate.types = Array.from(uniqueCodes);
      }

      if (!sessionUpdate.request) {
        const firstSelectedCode = this.codes?.[0];
        for (const question of this.systemExpert.questions) {
          if (question.answers?.some((answer: any) => answer.code === firstSelectedCode)) {
            sessionUpdate.request = question.type;
            break;
          }
          if (question.questions) {
            for (const subQuestion of question.questions) {
              if (subQuestion.answers?.some((answer: any) => answer.code === firstSelectedCode)) {
                sessionUpdate.request = subQuestion.type;
                break;
              }
            }
          }
        }
      }
    }
    return sessionUpdate;
  }

  zoneSelected(zone: string) {
    this.zone = zone;
  }

  public handleAnswers(answers: string[]): void {
    this.codes = answers;
  }

  private syncButtonStates(): void {
    if (this.stepperService.currentStep === 'survey' && this.nextStep === 'questions') {
      this.showUpdateButton = true;
      this.showNextButton = false;
      this.cdr.detectChanges();
    } else if (this.nextStep === 'SystemExpertDiagnoses') {
      this.showUpdateButton = false;
      this.showNextButton = true;
      this.cdr.detectChanges();
    } else {
      this.showUpdateButton = false;
      this.showNextButton = true;
    }
  }

  private checkPayment(): Observable<any> {
    const baseUrl = window.location.hostname === 'localhost' ? 'http://localhost:4200' : 'https://' + environment.hostname;
    const userData = JSON.parse(this.storage.getItem('userData')!) as UserAccountDTO;
    const individualId = userData?.individualId;
    const paymentConfObj: IInitializePayment = {
      sodType: history.state.sodType,
      trackingCode: '',
      sodBeneficiary: individualId,
      urlDone: btoa(baseUrl + '/medical-consultations/discover-care-pathway'),
      urlBack: btoa(baseUrl + '/medical-consultations/discover-care-pathway'),
      storeCard: false,
    };
    this.http.initializePayment(paymentConfObj).subscribe((res: { paymentSystemRedirectUrl: string; rateNumber: string }) => {
      this.body['rateNumber'] = res.rateNumber;
      this.storage.setItem('bodyAppointment', this.body);
      window.location.href = res.paymentSystemRedirectUrl;
    });
    return of(false);
  }

  public setActiveUser(user: any) {
    this.http.userMedicalProfileData(user.individualId).subscribe((res) => {
      this.dataService.setMedicalData({ lastMeasurement: res });
      this.steps![this.stepperService.indexCurrentStep].hasTipside = true;
      this.appointmentStepperService.setMainUser(user);
      this.cdr.detectChanges();
    });
  }

  protected setButtonText(): string {
    if (this.stepperService.currentStep === 'summary') {
      if (this.payment) {
        return this.translate.instant('buttons.continue_pay');
      } else {
        return this.translate.instant('buttons.confirm');
      }
    }
    return this.translate.instant('buttons.next');
  }

  private modifyAppointment(): Observable<any> {
    const appointment = JSON.parse(localStorage.getItem('appointment')!);
    const body = {
      specialist: appointment.specialist,
      specialistId: appointment.specialistId,
      phoneNumber: appointment.phoneNumber,
      message: appointment.message,
      currentContactId: appointment.individualId,
      availabilities: this.body.availabilities,
      dossierCode: appointment.dossierCode,
      missionId: appointment.missionId,
    };
    return this.http.modifyAppointment(body, appointment.individualId, appointment.consultType);
  }

  private setCalendarConfigs(res: any) {
    this.minAppointments = res.output.proposedMinimumSlots;
    this.maxAppointments = res.output.proposedMaximumSlots;
    this.dates = this.groupScheduleByDate(res.output.scheduleItems);
    this.oldDates = JSON.parse(JSON.stringify(this.dates));
  }

  private setSurveys(survey: any) {
    if (survey.length === 0) return {};
    const grouped = survey.reduce(
      (acc: any, obj: any) => {
        const key = obj.surveyValueQuestion;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
      },
      {} as Record<string, any[]>
    );

    return Object.keys(grouped).map((key) => ({
      category: key,
      items: grouped[key],
    }));
  }

  private sendUpdateUser(): void {
    const user = this.appointmentStepperService.getMainUser();
    this.http.getAccountdDataNoConnectionValidations(user?.individualId!).subscribe((accountData: AccountDataDTO) => {
      const body = { ...this.profileInputChosen?.value.personalData };
      const data = { ...accountData.customer };
      this.updatedUser = this.updateUserData(data, body);
      this.http.updateAccount(this.updatedUser).subscribe((_) => {
        return;
      });
    });
  }

  private updateUserData(user: any, updated: any): void {
    if (updated.name !== undefined) user.name = updated.name;
    if (updated.surname !== undefined) user.surname = updated.surname;
    if (updated.taxId !== undefined) user.taxId = updated.taxId;
    if (updated.postalCode !== undefined) user.postalCode = updated.postalCode;
    if (updated.address !== undefined) user.address = updated.address;
    if (updated.birthCountry?.value) {
      user.birthCountry = {
        code: updated.birthCountry.value,
        description: updated.birthCountry.text,
      };
    }
    if (updated.birthDistrict?.value) {
      user.birthDistrict = {
        code: updated.birthDistrict.value,
        description: updated.birthDistrict.text,
      };
    }
    if (updated.birthCity?.value) {
      user.birthCity = {
        code: updated.birthCity.value,
        description: updated.birthCity.text,
      };
    }
    return user;
  }

  private sendUpdateDoctorData() {
    const user = this.appointmentStepperService.getMainUser();
    this.http.saveDoctorDetails(user?.individualId!, this.profileInputChosen?.value?.medicalData).subscribe((res) => {
      console.log(res);
    });
  }

  private getBodyForSchedule() {
    if (this.consultTypePhone === 'CareManager') {
      const doctor = this.profileInputChosen?.value.medicalData;
      this.body.doctor = {
        name: doctor.name,
        surname: doctor.surname,
        address: doctor.address,
        phone: doctor.phone,
        creationDatetime: new Date().toISOString(),
        lastUpdateDatetime: new Date().toISOString(),
      };
    }
    return this.body;
  }

  protected handleNewProfile() {
    this.getProfiles();
  }
}
